<template>
  <div v-if="share && !isUnlock"></div>
  <div v-else class="main-container">
    <div class="bread">
      <router-link :to="{ name: 'MemberHomeworkIndex' }">我的作业</router-link>
      <span class="slash">/</span>
      <span class="current">作业详情</span>
    </div>
    <div class="line"></div>
    <div class="content">
      <div class="title">{{ detail.hw_name }}</div>
      <div>
        <template v-if="detail.hw_type == 1">
          <div class="row">
            <label class="label">所属课程</label>
            <span class="text">{{ detail.title }}</span>
          </div>
          <div class="row">
            <label class="label">所属课节</label>
            <span class="text">{{ detail.periods_name || '-' }}</span>
          </div>
        </template>
        <template v-else>
          <div class="row">
            <label class="label">所属课次</label>
            <span class="text mar4" v-if="$store.getters.getSwitch('classify')">
              {{ detail.arrange_detail.classify_name || '' }}
            </span>
            <span class="mar4" v-if="$store.getters.getSwitch('grade')">
              {{ detail.arrange_detail.grade_name || '' }}
            </span>
            <span class="mar4">
              {{ detail.arrange_detail.subject_name || '' }}
            </span>
            <span>
              {{ detail.arrange_detail.arrange_time }}
            </span>
          </div>
          <div class="row">
            <label class="label">课次类型</label>
            <span class="text">{{ getClassType(detail.hw_class_type) }}</span>
          </div>
        </template>
        <div class="row">
          <label class="label">作业备注</label>
          <span class="text">{{ detail.hw_remark || '-' }}</span>
        </div>
        <!-- <div class="row">
          <label class="label">截止时间</label>
          <span class="text">{{ detail.end_time | tsFormatLong }}</span>
        </div> -->
        <div class="row">
          <label class="label">题目数量</label>
          <span class="text">{{ detail.ques_count }}道题</span>
        </div>
        <div class="row">
          <label class="label">作业总分</label>
          <span class="text">
            {{ detail.is_set_score == 2 ? detail.score : '-' }}
          </span>
        </div>
      </div>
      <div v-if="share" class="btns">
        <a href="javascript:void(0)" class="link" @click="handleGo">
          {{ getBtnTextByStatus() }}
        </a>
      </div>
      <div v-else>
        <router-link v-if="detail.status == 5" class="link" :to="{ name: 'MemberHomeworkIndex' }">
          返回
        </router-link>
        <a href="javascript:void(0)" v-else-if="detail.status === 1" class="link" @click="go">
          {{ detail.is_continue_answer ? '继续作答' : '立即作答' }}
        </a>
        <router-link v-else class="link" :to="{ name: 'HomeworkAnalysis', query: { id: id } }">
          查看作业
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
import { PeriodsType } from '@/utils/enums.js';
export default {
  name: 'HomeworkIntro',
  data() {
    return {
      isUnlock: false,
      id: +this.$route.query.id,
      hw_id: this.$route.query.hw_id,
      share: this.$route.query.share,
      noPermission: false,
      detail: {
        arrange_detail: {},
      },
    };
  },
  async created() {
    // 有share说明是通过分享进入页面
    const params = {};
    if (this.share) {
      params.hw_id = this.id;
    } else if (!this.id) {
      params.hw_id = this.hw_id;
    } else {
      params.id = this.id;
    }
    this.detail = await this.$http.get('/api/app/user/homework/detail', params);
    this.id = this.detail.id;
    this.isUnlock = true;
    if (this.detail.id === 0 && this.share && this.$store.state.token) {
      // 登录后无权限
      this.noPermission = true;
      this.$alert('很抱歉，您当前登录手机号无该课节服务权益，请更换为上课手机号登录。', '提示', {
        confirmButtonText: '退出，重新登录',
        showClose: false,
        callback: () => {
          this.$store.commit('logout');
          this.$router.push({
            name: 'Login',
            query: { relogin: 1 },
          });
        },
      });
    }
    if (this.detail.status == 5) {
      this.$warning('该作业已经被撤回');
    }
  },
  methods: {
    getBtnTextByStatus() {
      const textMap = {
        '1-0': '开始作答',
        0: '开始作答',
        1: '继续作答',
        2: '答题情况',
        6: '作答结果',
        7: '查看结果',
      };
      let status = this.detail.status;
      if (status === 1) {
        // 0显示「开始作答」，非0=》「继续作答」
        if (this.detail.is_continue_answer === 0) {
          status = '1-0';
        }
      }
      return textMap[status];
    },
    handleGo() {
      if (this.noPermission) return;
      if (!this.$store.state.token) {
        this.$router.push({
          name: 'Login',
          query: { relogin: 1 },
        });
        return;
      }
      const status = this.detail.status;
      switch (status) {
        case 1:
          this.go();
          break;
        case 2:
        case 6:
        case 7:
          // eslint-disable-next-line no-case-declarations
          const query = { id: this.id };
          if (status === 6) {
            // 是带订正状态
            query.type = 'correct';
          }
          this.$router.push({
            name: 'HomeworkAnalysis',
            query,
          });
      }
    },
    go() {
      this.$router.push({
        name: 'HomeworkDo',
        query: { id: this.id },
      });
    },
    getClassType(type) {
      return PeriodsType.getValue(type) || '--';
    },
  },
};
</script>
<style lang="scss" scoped>
.main-container {
  overflow: hidden;
}
.line {
  height: 15px;
  background-image: url('~@/assets/images/homework/intro@2x.png');
  background-size: 1198px 15px;
  background-position: center center;
}
.content {
  background: white;
  box-shadow: 0px 3px 9px 0px rgba(0, 0, 0, 0.04);
  border-radius: 0 0 3px 3px;
  overflow: hidden;
  margin-bottom: 30px;
}
.title {
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  margin: 25px 0 49px 0;
}
.row {
  display: flex;
  padding: 0 76px;
  font-size: 14px;
  margin-bottom: 20px;

  .label {
    color: #999999;
    margin-right: 53px;
    flex-shrink: 0;
  }
  .mar4 {
    margin-right: 4px;
  }
}
.link {
  display: block;
  margin: 10px auto 41px auto;
  width: 160px;
  height: 42px;
  line-height: 42px;
  text-align: center;
  background: $primary-color;
  border-radius: 21px;
  font-size: 16px;
  font-weight: 500;
  color: white;
}
</style>
